module.exports = __webpack_public_path__ + "static/media/Chapter2.78b2ac50.pdf";